import { render, staticRenderFns } from "./VariationAdd.vue?vue&type=template&id=504e056a&scoped=true"
import script from "./VariationAdd.vue?vue&type=script&lang=js"
export * from "./VariationAdd.vue?vue&type=script&lang=js"
import style0 from "./VariationAdd.vue?vue&type=style&index=0&id=504e056a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e056a",
  null
  
)

export default component.exports